export const Step = {
  Lookup: 'Lookup',
  SelectOffer: 'SelectOffer',
  Gap: 'Gap',
  Review: 'Review',
  ExitToDashboard: 'ExitToDashboard',
  ExitToApplicantGate: 'ExitToApplicantGate',
  ExitToNoOffers: 'ExitToNoOffers',
};
